import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environment/environment';

export interface ConsentInfoItem {
  label: string;
  text: string;
}

// Teilnehmerinformation und Zustimmungs-Checkboxen. Genutzt von der Accept-Seite und der Seite /consent.
// Das Formular enthält die Felder `terms` und (nur bei Teilnehmenden) `consent`; nichts ist vorangekreuzt.
@Component({
  standalone: false,
  selector: 'app-consent-checkboxes',
  templateUrl: './consent-checkboxes.component.html',
  styleUrls: ['./consent-checkboxes.component.scss']
})
export class ConsentCheckboxesComponent {
  @Input() form!: FormGroup;
  @Input() submitted = false;
  // Teilnehmende geben zusätzlich die Einwilligung in die Auswertung; Anwendende nur die Nutzungsbedingungen
  @Input() participant = true;
  @Input() company = '';
  // Zweck der Einladung: Code (z. B. team_development) oder bei "other" der freie Text
  @Input() purpose = '';
  @Input() purposeText = '';
  // Nutzungsbedingungen anzeigen (beim erneuten Zustimmen nur, wenn sie fehlen)
  @Input() showTerms = true;
  // Die Teilnehmerinformation steht nur auf der Einrichtungsseite, nicht beim erneuten Zustimmen
  @Input() showInfo = true;

  readonly termsUrl: string = (environment as any).termsUrl || '';
  readonly privacyUrl: string = (environment as any).privacyUrl || '';

  // Eine Checkbox wird erst nach dem Aufruf des Dokuments freigegeben (ohne Link gibt es nichts zu öffnen)
  termsViewed = !this.termsUrl;
  consentViewed = !this.privacyUrl;

  constructor(private translate: TranslateService) {}

  get purposeLabel(): string {
    if (!this.purpose) {
      return '';
    }
    if (this.purpose === 'other') {
      return this.purposeText;
    }
    const key = 'purposes.' + this.purpose;
    const label = this.translate.instant(key);
    return label === key ? '' : label;
  }

  get info(): ConsentInfoItem[] {
    const p = { company: this.company, purpose: this.purposeLabel };
    const t = (key: string) => this.translate.instant('acceptPage.' + key, p);
    const why = [t('infoWhyText'), this.purposeLabel ? t('infoPurposeText') : ''].filter(x => x).join(' ');
    return [
      { label: t('infoWho'), text: t('infoWhoText') },
      { label: t('infoWhy'), text: why },
      { label: t('infoSees'), text: t('infoSeesText') },
      { label: t('infoWhere'), text: t('infoWhereText') },
      { label: t('infoEval'), text: t('infoEvalText') },
      { label: t('infoHow'), text: t('infoHowText') },
      { label: t('infoFree'), text: t('infoFreeText') }
    ];
  }

  get f() {
    return this.form.controls;
  }
}
